import React from 'react';
import { SvgIcon } from 'material-ui';

const SwitchIcon = props => (
  <SvgIcon {...props} viewBox='0 0 23 3' style={{ height: 3, width: 23 }}>
    <g
      id='4'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      transform='translate(-244.000000, -489.000000)'
      strokeLinecap='square'
    >
      <path d='M245.807692,490.5 L265.259499,490.5' id='minus' stroke='#979797' strokeWidth='2' />
    </g>
  </SvgIcon>
);

export default SwitchIcon;



// WEBPACK FOOTER //
// ./src/icons/MinusIcon.js